import {LayoutGalleryOverview} from './LayoutGalleryOverview';
import {LayoutGalleryScroll} from './LayoutGalleryScroll';
import {LayoutGallerySlider} from './LayoutGallerySlider';

import {prebuiltLayoutPreviewImages} from '../constants';

const category = 'Gallery';

export const GalleryOverview = {
  category,
  displayName: 'Gallery Overview',
  previewImageURL: prebuiltLayoutPreviewImages.layoutGalleryOverview,
  layout: LayoutGalleryOverview,
};

export const GalleryScroll = {
  category,
  displayName: 'Gallery Scroll',
  previewImageURL: prebuiltLayoutPreviewImages.layoutGalleryScroll,
  layout: LayoutGalleryScroll,
};

export const GallerySlider = {
  category,
  displayName: 'Gallery Slider',
  previewImageURL: prebuiltLayoutPreviewImages.layoutGallerySlider,
  layout: LayoutGallerySlider,
};
